export default "__VITE_ASSET__D8Wf3onc__"